import React, { useEffect, useState } from "react"
import { useSiteContext } from "../hooks/use-site-context"
import { GatsbyImage, StaticImage } from "gatsby-plugin-image"
import { graphql, useStaticQuery } from "gatsby"
import { FaHeart } from "react-icons/fa"
import { MdPlayArrow, MdPause, MdVolumeOff, MdVolumeUp } from "react-icons/md"

const EnterFirstName = () => {
  const {
    setFirstName,
    mainAudio,
    setCurrentAudioStage,
    setCurrentStep,
    setAudioEnded,
    progressBarPercent,
    setProgressBarPercent,
    buttonClickAudio,
    userRegion,
    userCountry,
  } = useSiteContext()

  const [fName, setFName] = useState("")
  const [isFormNameError, setIsFormNameError] = useState(false)
  const [disappearing, setDisappearing] = useState(false)

  const handleClick = () => {
    let hasError = false

    if (fName.trim() === "") {
      hasError = true
      setIsFormNameError(true)
      // setTimeout(() => setIsFormNameError(false), 700)
    }

    if (hasError) {
      const isFirefox = navigator.userAgent.toLowerCase().includes("firefox")

      if (isFirefox) {
        // Custom smooth scroll for Firefox
        const smoothScrollToTop = () => {
          let currentScroll = window.scrollY
          if (currentScroll > 0) {
            window.scrollTo(0, currentScroll - currentScroll / 8) // Adjust easing factor if needed
            requestAnimationFrame(smoothScrollToTop)
          }
        }
        requestAnimationFrame(smoothScrollToTop)
      } else {
        // Native smooth scroll for Chrome, Safari, and others
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        })
      }
      return
    }

    buttonClickAudio.play()

    setFirstName(
      fName.trim().charAt(0).toUpperCase() + fName.trim().slice(1).toLowerCase()
    )
    setDisappearing(true)
    setTimeout(() => {
      setCurrentAudioStage("first-letter")
      mainAudio.src = `/audio/first-letter-${fName
        .trim()
        .charAt(0)
        .toLowerCase()}.mp3`
      mainAudio.play()
      setAudioEnded(false)
      setCurrentStep(4)
    }, 700)
    let currentTick = 0
    const intervalID = setInterval(() => {
      currentTick++
      if (currentTick >= 1390) {
        clearInterval(intervalID)
      } else {
        setProgressBarPercent(
          progressBarPercent => progressBarPercent + 0.02398
        )
      }
    }, 100)
  }

  return (
    <>
      <div
        className={`text-center fade-in ${
          disappearing ? "disappear transition duration-1000" : ""
        }`}
      >
        <h1 className="text-2xl font-bold text-white md:text-4xl">
          Next Step: Your FREE Personalized Reading!
        </h1>
        <p className="mt-6 text-lg font-semibold text-brand-gold">
          Enter your first name below:
        </p>
        <input
          value={fName}
          className={`${
            isFormNameError ? "ring-0 focus:ring-2" : "ring-0 focus:ring-2"
          } w-full max-w-xs p-2 mt-2 transition ring-brand-pink duration-150 ease-in-out rounded-sm outline-none md:max-w-sm focus:outline-none`}
          placeholder="Your first name"
          type="text"
          onChange={e => {
            setFName(e.target.value)
            // if (e.target.value.trim() !== "") setIsFormNameError(false);
          }}
          onKeyDown={e => {
            if (e.key === "Enter" && !disappearing) handleClick()
          }}
        />
        {isFormNameError && (
          <p className="max-w-xs mx-auto text-white bg-red-700 bg-opacity-60 md:max-w-sm">
            ☝ Please enter your first name.
          </p>
        )}
        {!isFormNameError && <br />}
        <div className="relative">
          <button
            onClick={() => handleClick()}
            disabled={disappearing}
            type="button"
            style={{
              backgroundColor: "rgb(168, 24, 129)",
              boxShadow: "0 0 1px 3px rgba(180, 23, 120, 0.45)",
            }}
            className="w-full max-w-xs py-2 mt-6 font-bold text-white rounded-sm continue-pulse md:max-w-sm"
          >
            Continue
          </button>
          <div className="absolute pointer-events-none right-12 sm:right-24 top-10">
            <StaticImage
              quality={95}
              loading={"eager"}
              src="../images/finger3.png"
              placeholder="blurred"
              alt={"Finger"}
              className={"w-10 h-10 sm:w-12 sm:h-12 finger-motion"}
            />
          </div>
        </div>
        <div className="flex w-full max-w-xs px-3 py-6 mx-auto mt-6 bg-black bg-opacity-50 md:px-4 md:max-w-sm">
          <div className="flex justify-center w-1/3">
            <StaticImage
              quality={95}
              loading={"eager"}
              src="../images/sarah-old.jpg"
              placeholder="blurred"
              alt={"Debbie"}
              className={``}
            />
          </div>
          <div className="w-2/3 pl-2">
            <p className="text-xs italic text-gray-100 md:text-sm">
              I was initially hesitant to share my name online, but I'm so glad
              I did. I felt{" "}
              <span className="font-bold">completely secure,</span> and the free
              reading provided by James was so accurate, it knocked my socks
              off!
              <br />
              <span className="font-bold">
                - Debbie B. (
                {userRegion ? `${userRegion}, ${userCountry}` : "Houston, Texas"})
              </span>
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default EnterFirstName
